import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import '@styles/theme.css'
import '@styles/utilities.css'
import '@styles/components.css'
import '@styles/marketing.css'
import '@styles/marketing/contact.css'
import '@styles/marketing/docs.css'
import '@styles/marketing/download.css'
import '@styles/marketing/landing.css'
import '@styles/marketing/support.css'

const rootEl = document.getElementById('root')
if (!rootEl) {
  throw new Error('#root element not found')
}

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
